import {AppConfig} from "@/modules/app/config";
import {CompanyConfig} from "@/modules/company/config";

export default {
    app: new AppConfig({
        APP_META_TITLE: 'Sushi-Studio',
        APP_META_TITLE_TEMPLATE: '{content} | Sushi-Studio - доставка суши и роллов в Иркутске',
        APP_META_DESCRIPTION: 'Доставка суши в Иркутске',
        APP_META_KEYWORDS: 'суши, роллы, филадельфия, канада, лосось, wok',
        API_GRAPHQL_URL: 'https://irkutsk.sushi-studio.ru/api-new/graphql/',
        API_CONFIG_URL: 'https://irkutsk.sushi-studio.ru/api-new/rest/app/settings',
    }),
    company: new CompanyConfig({
        MAX_OFFICE_COUNT: 40,
    }),
};
